<template>
  <div>
    <headline :content="$t('project.plan', { name: project.name })"></headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <ExplanationStatus :viewType="'plan'" class="btn-explain-plan"/>
        <ProjectPlanArea
          v-if="project"
          :layoutType="project.layoutType"
          :projectId="project.objectId"
          :isEdit="false" 
          :marketId="selectMarket"
          :areaBookingSummaryByProject="getAreaBookingSummaryByProject"
          :invoiceDueDateSummary="getInvoiceDueDateSummary"
          :hashMeterData="hashMeterData"
          :isLoadingSummary="isLoadingSummary"
        />
      </template>
    </layout>
  </div>
</template>

<script>
import ProjectPlanArea from "../../components/ProjectPlanArea.vue";
import Layout from "../../components/Layout"
import Headline from "../../components/Headline"
import { mapState, mapGetters } from "vuex"
import { Market ,Meter, DigitalMeter} from "../../classes"
import ExplanationStatus from "../../components/ExplanationStatus.vue";
export default {
  components: {
    ProjectPlanArea,
    Layout,
    Headline,
    ExplanationStatus
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      isLoading: false,
      selectMarket: null,
      markets: [],
      hashMeterData: {},
      meters : null,
      isLoadingSummary : false,
    };
  },
  computed: {
    ...mapGetters({
      getAreaBookingSummaryByProject: "area/getAreaBookingSummaryByProject",
      getInvoiceDueDateSummary: "area/getInvoiceDueDateSummary",
    }),
    ...mapState({
      // markets: state => state.markets.markets,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
  },
  async created() {
    if (this.admins && this.admins.length) {
      this.project = this.admins[0].project;
    } else if (this.employees && this.employees.length) {
      this.project = this.employees[0].project;
    }
    this.markets = await Market.getMarketByProject(this.projectId)
    if(this.markets.length){
      this.selectMarket = this.markets[0].objectId
    }
    this.getAreaBookings();
  },
  mounted() {
  },
  methods: {
    async getAreaBookings () {
      this.isLoadingSummary = true
      try {
        await this.$store.dispatch("area/getAreaBookingSummaryByProject", {
          projectId: this.projectId
        });
        await this.$store.dispatch("area/getInvoiceDueDateSummaryByProject", {
          projectId: this.projectId
        });
        await this.getSummaryDigitalMeterData();
        this.isLoadingSummary = false
      } catch (err) {
        this.isLoadingSummary = false
        console.log(err);
      }
    },
    async getSummaryDigitalMeterData(){
      this.hashMeterData = {}
      let promises = []
      this.meters = await Meter.getMeterByProject(this.projectId,'elec',true)
      for(let meter of this.meters){
        if (meter && meter.digitalMeterData && meter.digitalMeterData.type == "prepaid") {
            promises.push(
              DigitalMeter.getLatestMeterData(
                meter.digitalMeterData.partner,
                meter.digitalMeterData.type,
                meter.digitalMeterData.cust_id,
                null,
                new Date()
              )
            )
          let results = await Promise.all(promises)
          let hashDigitalMetersUnit = {}
          for (let result of results) {
            hashDigitalMetersUnit = {
              ...hashDigitalMetersUnit,
              ...result
            }
          }
          let meterData = hashDigitalMetersUnit[`${meter.digitalMeterData.cust_id}_${meter.digitalMeterData.meter_id}`]
          if (!this.hashMeterData[meter.area.objectId] && meterData) {
            this.hashMeterData[meter.area.objectId] = []
          }
          if(meterData){
            this.hashMeterData[meter.area.objectId].push({...meterData,meter})
          }
        }
      }
    },
  }

};
</script>

<style lang="scss" scoped>
  .btn-explain-plan {
    position: absolute;
    right: 45px;
    bottom: 50px;
    z-index: 10;
  }
</style>